/**
 * Hybrid Label Component
 * Automatically chooses between Tailwind and styled-components based on props
 */

import * as React from "react";
import Text from "@sproutsocial/seeds-react-text";
import { StyledLabel } from "./styles"; // Styled-components version
import { LabelTailwind } from "./LabelTailwind"; // Tailwind version
import { hasStyledProps } from "@sproutsocial/seeds-react-system-props";
import type { TypeLabelProps } from "./LabelTypes";

const LabelHybrid = ({
  htmlFor,
  required,
  children,
  ...rest
}: TypeLabelProps) => {
  if (hasStyledProps(rest)) {
    return (
      <StyledLabel
        fontSize={200}
        fontWeight="semibold"
        color="text.headline"
        data-qa-label={htmlFor}
        htmlFor={htmlFor}
        {...rest}
      >
        {children}
        {required && (
          <Text ml={100} aria-hidden>
            *
          </Text>
        )}
      </StyledLabel>
    );
  }

  // Use Tailwind version (preferred - better performance)
  return (
    <LabelTailwind htmlFor={htmlFor} required={required} {...rest}>
      {children}
    </LabelTailwind>
  );
};

export default LabelHybrid;
